// extracted by mini-css-extract-plugin
export default {"header":"header_header__Tawrc","x":"header_x__iIXov","exitMobile":"header_exitMobile__bZ6PE","gray":"header_gray__QOYVs","dot":"header_dot__W1g82"};